<template>
  <div>
    <el-drawer
      :title="`${itemId ? '编辑' : '新增'}联系人`"
      custom-class="add-drawer"
      :visible.sync="drawer"
      :direction="$utils.isMobile() ? 'btt' : 'rtl'"
      :before-close="handleClose"
      :size="$utils.isMobile() ? '85%' : '35rem'"
      :wrapperClosable="false"
    >
      <div class="form-content">
        <el-form
          ref="addForm"
          :label-position="$utils.isMobile() ? 'top' : 'left'"
          label-width="100px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入内容" clearable></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="form.sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-select style="width: 100%" v-model="form.position" placeholder="请选择" filterable multiple>
              <el-option v-for="item in positionOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="就职状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in employStatusOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入内容" clearable></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input v-model="form.email" placeholder="请输入内容" clearable></el-input>
          </el-form-item>
          <el-form-item label="微信号">
            <el-input v-model="form.wechat" placeholder="请输入内容" clearable></el-input>
          </el-form-item>
          <el-form-item label="QQ号">
            <el-input v-model="form.qq" placeholder="请输入内容" clearable></el-input>
          </el-form-item>
          <el-form-item label="座机号" prop="telephone">
            <el-input v-model="form.telephone" placeholder="请输入内容" clearable></el-input>
          </el-form-item>
          <el-form-item label="所属部门">
            <el-input v-model="form.department" placeholder="请输入内容" clearable></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button class="save-btn" @click="save" :loading="loadSave">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <drawer-close
        v-if="!$utils.isMobile()"
        :visible="drawer"
        right="35rem"
        @close="handleClose"
      ></drawer-close>
    </el-drawer>
  </div>
</template>
<script>
import {
    saveSchoolPeople,
  updateSchoolPeople,
  findEnumPositionList,
  findOneSchoolPeopleById,
} from "@/api/customer/index.js";
import { mapState } from "vuex";
import drawerClose from "../../../components/public/drawerClose.vue";
export default {
  components: { drawerClose },
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
    sId: {
      type: String,
      default: "",
    },
    itemId: {
      type: String,
      default: "",
    },
  },
  data() {
    let checkEmail = (rule, value, callback) => {
      //邮箱校验
      const mailReg = /^([a-zA-Z0-9-])+@([a-zA-Z0-9-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/;
      if (!value) {
        callback();
        return;
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    let checkTel = (rule, value, callback) => {
      //座机号校验
      const TelReg = /^(0\d{2,3})-\d{5,8}$/;
      if (!value) {
        callback();
        return;
      }
      setTimeout(() => {
        if (TelReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的座机号"));
        }
      }, 100);
    };
    let phoneTel = (rule, value, callback) => {
      //手机号校验
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback();
        return;
      }
      setTimeout(() => {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的手机号"));
        }
      }, 100);
    };

    return {
      direction: "rtl",
      labelPosition: "top",
      loadSave: false,
      form: {
        name: "",
        sex: "1",
        email: "",
        phone: "",
        telephone: "",
        wechat: "",
        department: "",
        position: [],
        status: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        email: [{ required: false, validator: checkEmail, trigger: "blur" }],
        telephone: [{ required: false, validator: checkTel, trigger: "blur" }],
        phone: [{ required: false, validator: phoneTel, trigger: "blur" }],
        position: [{ required: true, message: "请选择职位", trigger: "change" }],
        status: [{ required: true, message: "请选择就职状态", trigger: "change" }],
      },
      positionOptions: [],
    };
  },
  watch: {
    drawer(val) {
      if (val && this.itemId) {
        this.loadSave = false;
        this.findOneSchoolPeopleByIdApi();
      }
    },
  },
  computed: {
    ...mapState(["productList", "employStatusOptions"]), // 映射 state.count 到组件中的 computed 属性
  },
  created() {
    this.findEnumPositionListApi();
  },
  methods: {
    findOneSchoolPeopleByIdApi() {
      findOneSchoolPeopleById({
        id: this.itemId,
      })
        .then((res) => {
          this.form = {
            ...res.data,
            sex: res.data.sex + "",
            position: res.data.position.split(','),
          };
        })
        .catch((err) => {
          this.$MessageBox.MessageWarning(err.data.msg);
        });
    },
    // 查询学校列表
    findEnumPositionListApi() {
      findEnumPositionList()
        .then((res) => {
          this.positionOptions = res.data;
        })
        .catch((err) => {
          this.$MessageBox.MessageWarning(err.data.msg);
        });
    },
    save() {
      this.loadSave = true;
      this.$refs.addForm.validate((valid) => {
        console.log("======= valid =======\n", valid);
        if (valid) {
          let param = {
            ...this.form,
            position: this.form.position.join(','),
            sId: this.sId,
          };
          if (this.itemId) {
            param.id = this.itemId;
          }
            let request = this.itemId ? updateSchoolPeople : saveSchoolPeople;
          request(param)
            .then(() => {
              this.$MessageBox.MessageSuccess("保存成功");
              this.$emit("updateList", this.itemId ? "edit" : "add");
              this.handleClose();
            })
            .catch((err) => {
              this.$MessageBox.MessageWarning(err.data.msg);
              this.loadSave = false;
            });
        } else {
          this.loadSave = false;
          return;
        }
      });
    },
    handleClose() {
      this.form = {
        name: "",
        sex: "1",
        email: "",
        phone: "",
        telephone: "",
        wechat: "",
        department: "",
        position: [],
        status: "",
      };
      this.loadSave = false;
      this.title = "新增";
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate();
        this.$emit("update:drawer", false);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.save-btn {
  width: 6.9rem;
  height: 2.38rem;
  background: $primary-btn-color;
  color: #fff;
  border: none;
  border-radius: 6px;
  display: inline-block;
  margin: 0.5rem 0 3rem;
  cursor: pointer;
}
</style>